import { useState, useEffect, useCallback } from "react";

export function CountdownTimerSlider({ closingTime }) {
  // Helper: parse UTC safely
  const parseUTC = (timeStr) => {
    if (!timeStr) return null;

    // If already ISO 8601 UTC, parse directly
    if (timeStr.endsWith("Z")) return new Date(timeStr);

    // If format like "YYYY-MM-DD HH:MM:SS", convert to ISO UTC
    const isoStr = timeStr.replace(" ", "T") + "Z";
    return new Date(isoStr);
  };

  const calculateTimeLeft = useCallback(() => {
    const nowUTC = new Date();
    const endUTC = parseUTC(closingTime);

    if (!endUTC) return null;

    const difference = endUTC - nowUTC;
    if (difference <= 0) return null;

    return {
      days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(
        2,
        "0"
      ),
      hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(
        2,
        "0"
      ),
      minutes: String(Math.floor((difference / 1000 / 60) % 60)).padStart(
        2,
        "0"
      ),
      seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, "0"),
    };
  }, [closingTime]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timerId = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timerId);
  }, [calculateTimeLeft]);

  if (!timeLeft) {
    return (
      <div
        className="countdown-timer"
        style={{
          fontWeight: 800,
          fontSize: "20px",
          gap: "7px",
          display: "flex",
        }}
      >
        <div>Expired</div>
      </div>
    );
  }

  return (
    <div className="offer-timer">
      <span>Auction Will Be End:</span>
      <div className="countdown-timer">
        <ul>
          <li>
            {timeLeft.days} Day<span>Days</span>
          </li>
          <li>:</li>
          <li>
            {timeLeft.hours} Hours
          </li>
          <li>:</li>
          <li>
            {timeLeft.minutes} Min
          </li>
          <li>:</li>
          <li>
            {timeLeft.seconds} Sec
          </li>
        </ul>
      </div>
    </div>
  );
}
